import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import store from "stores/interfaces";
import {
  Select,
  MenuItem,
  SelectChangeEvent,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const MediumListOfficialPlaylistTabs = () => {
  const d = useAppDispatch();
  const tab = useAppSelector((state) => {
    return store.getAppState(state, "userMediumListOfficialPlaylistTab");
  });
  const playlists = useAppSelector((state) => {
    return store.getAppState(state, "officialPlaylists");
  });
  const [t] = useTranslation();

  const onChange = useCallback(
    (e: SelectChangeEvent) => {
      d(
        store.appStateMutate((state) => {
          state.userMediumListOfficialPlaylistTab = e.target.value;
        })
      );
    },
    [d]
  );

  return (
    <FormControl
      variant="outlined"
      sx={{
        maxWidth: "300px",
        marginLeft: "16px",
        marginBottom: "16px",
      }}
    >
      <InputLabel id="select-click-action-label">
        {t("表示カテゴリ")}
      </InputLabel>
      <Select
        size="small"
        labelId="bgm-select-label"
        label={t("表示カテゴリ")}
        value={tab}
        onChange={onChange}
        MenuProps={{
          sx: {
            maxHeight: "470px",
          },
        }}
      >
        <MenuItem value="all">{t("すべて")}</MenuItem>
        {playlists.map((playlist) => (
          <MenuItem key={playlist.id} value={playlist.id}>
            {t(playlist.name)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(MediumListOfficialPlaylistTabs);
